import { writable } from 'svelte/store';

export let score = writable(0);
